// Buy Button with scroll threshold + footer visibility
(function() {
  // Get the button and footer elements
  const buyButton = document.querySelector('.vijn-events-new-buy-button-mobile');
  const footerSection = document.getElementById('vijn-footer-section');
  
  // Exit if button doesn't exist
  if (!buyButton) return;
  
  // Calculate the threshold (10% of viewport height)
  let scrollThreshold = window.innerHeight * 0.10;
  
  // Initially hide the button (before any rendering)
  buyButton.style.opacity = '0';
  buyButton.style.visibility = 'hidden';
  buyButton.style.transform = 'translateY(100px)';
  buyButton.style.transition = 'opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1), transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.4s';
  
  // Function to check if footer is in viewport
  function isFooterInViewport() {
    if (!footerSection) return false;
    
    const rect = footerSection.getBoundingClientRect();
    return (
      rect.top < window.innerHeight && 
      rect.bottom >= 0
    );
  }
  
  // Function to handle scroll
  function handleScroll() {
    // Get current scroll position
    const scrollPosition = window.scrollY || window.pageYOffset;
    
    // Check if footer is in viewport
    const footerVisible = isFooterInViewport();
    
    // Show button if scrolled past threshold AND footer is not visible
    if (scrollPosition > scrollThreshold && !footerVisible) {
      buyButton.style.opacity = '1';
      buyButton.style.visibility = 'visible';
      buyButton.style.transform = 'translateY(0)';
    } else {
      buyButton.style.opacity = '0';
      buyButton.style.visibility = 'hidden';
      buyButton.style.transform = 'translateY(100px)';
    }
  }
  
  // Listen for scroll events with passive option for better performance
  window.addEventListener('scroll', handleScroll, { passive: true });
  
  // Check initial state in case page is already scrolled
  handleScroll();
  
  // Recalculate threshold on window resize
  window.addEventListener('resize', function() {
    scrollThreshold = window.innerHeight * 0.10;
    handleScroll();
  });
})();

// Mobile Nav with footer visibility only (no scroll threshold)
(function() {
  // Get the mobile nav and footer elements
  const mobileNav = document.querySelector('.vijn-event-mobile-nav');
  const footerSection = document.getElementById('vijn-footer-section');
  
  // Exit if mobile nav doesn't exist
  if (!mobileNav) return;
  
  // Set up initial styles and transition
  mobileNav.style.transition = 'opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1), transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.4s';
  
  // Function to check if footer is in viewport
  function isFooterInViewport() {
    if (!footerSection) return false;
    
    const rect = footerSection.getBoundingClientRect();
    return (
      rect.top < window.innerHeight && 
      rect.bottom >= 0
    );
  }
  
  // Function to handle scroll for mobile nav
  function handleMobileNavScroll() {
    // Check if footer is in viewport
    const footerVisible = isFooterInViewport();
    
    // Hide mobile nav if footer is visible, show otherwise
    if (footerVisible) {
      mobileNav.style.opacity = '0';
      mobileNav.style.visibility = 'hidden';
      mobileNav.style.transform = 'translateY(100%)';
    } else {
      mobileNav.style.opacity = '1';
      mobileNav.style.visibility = 'visible';
      mobileNav.style.transform = 'translateY(0)';
    }
  }
  
  // Listen for scroll events with passive option for better performance
  window.addEventListener('scroll', handleMobileNavScroll, { passive: true });
  
  // Check initial state
  handleMobileNavScroll();
  
  // Recheck on window resize
  window.addEventListener('resize', handleMobileNavScroll);
})();


  // // Desktop tabs
  // document.addEventListener('DOMContentLoaded', function() {
  //   const tabs = document.querySelectorAll('.vijn-event-tab');
  //   const tabContents = document.querySelectorAll('.vijn-event-tab-content');

  //   tabs.forEach(tab => {
  //     tab.addEventListener('click', function() {
  //       const targetTab = this.getAttribute('data-tab');
        
  //       tabs.forEach(t => t.classList.remove('vijn-event-tab-active'));
  //       tabContents.forEach(tc => tc.classList.remove('vijn-event-tab-active'));
        
  //       this.classList.add('vijn-event-tab-active');
  //       document.getElementById(`vijn-tab-${targetTab}`).classList.add('vijn-event-tab-active');
  //     });
  //   });
  // });

  // Scroll Spy Tab Navigation
(function() {
  // Get all tab buttons and content sections
  const tabButtons = document.querySelectorAll('.vijn-event-tab');
  const tabContents = document.querySelectorAll('.vijn-event-tab-content');
  
  // Exit if elements don't exist
  if (!tabButtons.length || !tabContents.length) return;
  
  // Smooth scroll to section when tab is clicked
  tabButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Get the target section ID from data attribute
      const targetId = this.getAttribute('data-tab');
      const targetSection = document.getElementById(`vijn-tab-${targetId}`);
      
      if (targetSection) {
        // Calculate offset (adjust this value based on your fixed header height)
        const headerOffset = 100; // Adjust this value as needed
        const elementPosition = targetSection.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        
        // Smooth scroll to the section
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
  
  // Scroll Spy: Highlight active tab based on scroll position
  function updateActiveTab() {
    // Get current scroll position
    const scrollPosition = window.scrollY + 150; // Add offset for better triggering
    
    let currentSection = null;
    
    // Find which section is currently in view
    tabContents.forEach(section => {
      const sectionTop = section.offsetTop;
      const sectionBottom = sectionTop + section.offsetHeight;
      
      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        currentSection = section;
      }
    });
    
    // Update active tab button
    if (currentSection) {
      const currentId = currentSection.id.replace('vijn-tab-', '');
      
      // Remove active class from all tabs
      tabButtons.forEach(tab => tab.classList.remove('vijn-event-tab-active'));
      
      // Add active class to current tab
      const activeTab = document.querySelector(`.vijn-event-tab[data-tab="${currentId}"]`);
      if (activeTab) {
        activeTab.classList.add('vijn-event-tab-active');
      }
    }
  }
  
  // Listen for scroll events
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    // Debounce for better performance
    if (scrollTimeout) {
      window.cancelAnimationFrame(scrollTimeout);
    }
    
    scrollTimeout = window.requestAnimationFrame(function() {
      updateActiveTab();
    });
  }, { passive: true });
  
  // Initial check on page load
  updateActiveTab();
  
  // Update on window resize
  window.addEventListener('resize', updateActiveTab);
})();